import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { Seller } from '@40seas/entities/sellers';
import { BaseEntity, Currency, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { ConnectedAccountChargeStatus } from './connected-account.charge.status.enum';
import { ConnectedAccountEntityType } from './connected-account.entity.enum';
import { ProviderType } from './provider.type.enum';

export const ConnectedAccountChargeSchema = WithBaseEntitySchema(
    z.object({
        providerId: z.string().optional(),
        providerType: EnumSchema(ProviderType),
        status: EnumSchema(ConnectedAccountChargeStatus),
        entityType: EnumSchema(ConnectedAccountEntityType),
        entitiesIds: z.array(z.string()).optional(),
        amount: z.number(),
        currency: EnumSchema(Currency),
        shortReferenceId: z.string().optional(),
    }),
).strict();

export class ConnectedAccountCharge extends FromSchema(ConnectedAccountChargeSchema) implements BaseEntity {
    id: string;
    entitiesIds: string[];
    entityType: ConnectedAccountEntityType;
    providerType: ProviderType;
    providerId?: string;
    status: ConnectedAccountChargeStatus;
    amount: number;
    currency: Currency;
    shortReferenceId?: string;
    seller?: string | Seller;
    tenantId: string;
    createdAt?: Date;
    updatedAt?: Date;
    createdBy?: Executor;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
